import { ClipLoader } from 'react-spinners';

const LoadingSpinner = () => {
  return (
    <div style={styles.spinnerContainer}>
      <ClipLoader size={150} color={"#123abc"} loading={true} />
    </div>
  );
};

const styles = {
  spinnerContainer: {
    position: 'fixed',  
    top: 0,             
    left: 0,            
    width: '100%', 
    height: '100vh',
    display: 'flex',    
    justifyContent: 'center',
    alignItems: 'center',  
    backgroundColor: 'rgba(255, 255, 255, 0.5)'
  }
};

export default LoadingSpinner;
